import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=d32071f2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=d32071f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32071f2",
  null
  
)

export default component.exports